"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NAV_MODULE_LABELS = exports.NAV_MODULE_CODES = void 0;
exports.isNavModuleCode = isNavModuleCode;
/**
 * Role -> Module sidebar-visibility layer (separate from the fine-grained
 * CRUD permission catalog in `permissions/*.permissions.ts`). This is the
 * single source of truth for the 16 top-level/nested sidebar sections
 * defined in `frontend/src/config/navigation-registry.ts`'s `group()`
 * calls — that file imports `NavModuleCode` from here so the registry and
 * the RBAC layer can never drift apart.
 *
 * Deliberately a plain string-literal union, not a Postgres enum: a role's
 * `moduleCode` grant is stored as a VARCHAR (see `RoleModule` in
 * schema.prisma) validated against this array at the application layer.
 * If a dynamic, tenant-configurable "Module Master" catalog is ever built
 * later, only this array's source (and `NAV_MODULE_LABELS`) needs to
 * change to read from a table instead — the JWT claim shape, the
 * `RoleModule` column, and the sidebar's gating logic all stay untouched.
 */
exports.NAV_MODULE_CODES = [
    'DASHBOARD',
    'FRONT_OFFICE',
    'CLINICAL',
    'CLINICAL_OPD',
    'CLINICAL_IPD',
    'DIAGNOSTICS',
    'LABORATORY',
    'RADIOLOGY',
    'PHARMACY',
    'BILLING_FINANCE',
    'BILLING',
    /*
      THE MAIN COUNTER (desk, 2026-08-28: "this should not be Finance... keep
      separate as a Main Counter").
  
      Its own section rather than a shelf inside Billing & Finance, and its own
      module grant with it. Finance is where the books are closed; the Main
      Counter is the live custody of cash — which drawers are open, whose shift is
      unsettled, who accepts a count. They are read by different people at
      different times of day, and a role that oversees counters has no business
      inheriting the general ledger to do it.
    */
    'MAIN_COUNTER',
    'INSURANCE',
    'MATERIALS',
    'HR',
    'REPORTS',
    'ADMINISTRATION',
];
exports.NAV_MODULE_LABELS = {
    DASHBOARD: 'Dashboard',
    FRONT_OFFICE: 'Front Office',
    CLINICAL: 'Clinical',
    CLINICAL_OPD: 'Clinical — OPD',
    CLINICAL_IPD: 'Clinical — IPD',
    DIAGNOSTICS: 'Diagnostics',
    LABORATORY: 'Diagnostics — Laboratory',
    RADIOLOGY: 'Diagnostics — Radiology',
    PHARMACY: 'Pharmacy',
    BILLING_FINANCE: 'Billing & Finance',
    BILLING: 'Billing & Finance — Billing',
    MAIN_COUNTER: 'Main Counter',
    INSURANCE: 'Insurance',
    MATERIALS: 'Materials',
    HR: 'Human Resources',
    REPORTS: 'Reports & Analytics',
    ADMINISTRATION: 'Administration',
};
function isNavModuleCode(value) {
    return exports.NAV_MODULE_CODES.includes(value);
}
//# sourceMappingURL=module-codes.js.map